import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchSafetyTotal } from 'queries/safety/safety'
import { ShortageFetchProps } from 'types/api'
import { IResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useSafetyTotal({
    env,
    accessToken,
    location,
    dynamicSubPath,
    filters,
}: ShortageFetchProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.SAFETY_TOTAL, location],
        () =>
            fetchSafetyTotal({
                env,
                accessToken,
                location,
                dynamicSubPath,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
